import { DateTime } from 'luxon'
import { CustomParams, SlidingParams } from '../types/SpyLaunchSettings'

export function spyLaunchSettingsConvertFromStateValue(spyLaunchSettings: any){
    if (spyLaunchSettings === undefined){
        return undefined
    }

    if (spyLaunchSettings.mode === 'sliding'){
        return {
            ...spyLaunchSettings
        }

    }

    if (spyLaunchSettings.mode === 'custom'){
        return {
            mode: 'custom',
            params: {
                periods: [
                    {
                        startDate: DateTime.fromISO(spyLaunchSettings.params.periods[0].startDate, { zone: 'UTC' }),
                        endDate: DateTime.fromISO(spyLaunchSettings.params.periods[0].endDate, { zone: 'UTC' })
                    }
                ]
            }
        } 
    }

}